import { MutationKey, QueryKey } from '@tanstack/react-query'
import { DefinitionNode, DocumentNode, OperationDefinitionNode } from 'graphql'

/**
 * Utility function that preserves compatibility with the existing codebase during migration from Apollo to Tanstack Query.
 * Apollo provides this utility by default.
 */
export { gql } from 'graphql-tag'

export const getKey = (documentNode: DocumentNode): MutationKey | QueryKey => {
  const operationNode: OperationDefinitionNode | undefined = documentNode.definitions.find(
    (def: DefinitionNode) => def.kind === 'OperationDefinition',
  )

  if (operationNode === undefined) {
    throw Error('DocumentNode should have an OperationDefinitionNode')
  } else if (operationNode.name === undefined) {
    throw Error('OperationDefinitionNode should have a name')
  } else {
    return [operationNode.name.value]
  }
}
